import Vue from 'vue'
import Vuetify from 'vuetify'

Vue.use(Vuetify)

const opts = {
  defaultTheme: 'dark',
}

export default new Vuetify(opts)
